import {useQuery} from "@tanstack/react-query";
import {readAddressListApi} from "../../../../../api/correspondent/CorresspondentApi";

import {BasicSearchType} from "../../../../../types/common/basic";

type Props = {
    searchData: BasicSearchType;
};

/**
 * 고객 주소 탭 정보
 * @param param
 * @returns
 */
export const useReadAddressList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAddressList", searchData],
        queryFn: async () => await readAddressListApi(searchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
